import React from "react";

import ReactDOM from "react-dom";

import { LanguageSelection } from "@skillshare/ui-components/components/LanguageSelection";
import { ApolloClientManager } from "@skillshare/ui-components/shared/apollo";
import { Providers } from "@skillshare/ui-components/shared/providers";

import { ReactBoneIntlProvider } from "../utils/reactbone-intl-provider";
import getTreatment from "../views/modules/flags";

const LanguageSelectionHelper = ({ config, onLanguageChange, node, saveOnChange }) => {
  const pl_i18n_web = getTreatment('pl_i18n_web');
  const intl_lang_sel_dev = getTreatment('intl_lang_sel_dev');
  const { icon, label, padMenu, select, variant } = config;

  const apiHost = SS.serverBootstrap?.apiData?.host;
  const client = ApolloClientManager.getClient({
    uri: `${apiHost}/api/graphql`,
  });
  const isAuthenticated = !SS.currentUser.isGuest();
  const trackEventHandler = SS.EventTracker.trackingCallback();
  const width = node.dataset.width;

  if (node) {
    ReactDOM.render(
      <ReactBoneIntlProvider>
        <Providers
          apolloProviderProps={{ client }}
          authenticationProviderProps={{ isAuthenticated }}
          cookieProviderProps={{ cookies: {} }}
          defaultThemeProviderProps
          eventsProviderProps={{ trackEventHandler }}
          featureProviderProps={{ flags: { pl_i18n_web, intl_lang_sel_dev } }}
        >
          <LanguageSelection
            icon={icon}
            label={label}
            onLanguageChange={onLanguageChange}
            padMenu={padMenu}
            saveOnChange={saveOnChange}
            select={select}
            variant={variant}
            width={width}
          />
        </Providers>
        </ReactBoneIntlProvider>,
      node
    );

  }
};

export default LanguageSelectionHelper;
